import { render, staticRenderFns } from "./BankPaymentSuccess.vue?vue&type=template&id=dbbe8eb6&scoped=true"
import script from "./BankPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./BankPaymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./BankPaymentSuccess.vue?vue&type=style&index=0&id=dbbe8eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbe8eb6",
  null
  
)

export default component.exports